import {Component, ViewChild} from '@angular/core';
import {Nav, Platform, AlertController, NavController, Events} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {HomePage} from '../pages/home/home';
//import { ListPage } from '../pages/list/list';
import {TransactionsPage} from '../pages/transactions/transactions';
import {EnquiriesPage} from '../pages/enquiries/enquiries';
import {SplitPaneProvider} from '../providers/split-pane/split-pane';
import {LoginPage} from '../pages/login/login';
import {TabsPage} from '../pages/tabs/tabs';
import {RequestServiceProvider} from '../providers/request-service/request-service';
import {AgentPage} from '../pages/agent/agent';
import {PayBillsPage} from '../pages/pay-bills/pay-bills';
import {SettingsPage} from '../pages/settings/settings';
import {ProfileNewPage as ProfilePage} from '../pages/profile-new/profile-new';
import {OpenAccountPage} from '../pages/open-account/open-account';
import {BanksPage} from '../pages/banks/banks';
import {EventsPage} from '../pages/events/events';
import {MicroInsurancePage} from "../pages/micro-insurance/micro-insurance";
import {CashPickupPage} from "../pages/cash-pickup/cash-pickup";
import {PendingTransactionPage} from "../pages/pending-transaction/pending-transaction";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  public agentInfo;
  public image;
  public show = true;
  rootPage: any = LoginPage;
  pages: Array<{ title: string, component: any, icon: string, index?: number }>;

  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, public splitScreen: SplitPaneProvider, public auth: RequestServiceProvider,  private alertCtrl: AlertController, private event: Events) {


    this.event.subscribe('profile-image', (data) => {
      //console.log(data);
      if (data == undefined) {
        this.show = true;
      } else {
        this.show = false;
        this.image = data;
      }

    });

    this.event.subscribe('uploaded-image', (data) => {
      this.image = data;
    });

    this.event.subscribe('agent-info', (data) => {
      this.agentInfo = data;
    });

    if (auth.loggedIn()) {
      this.rootPage = TabsPage;
    } else {
      this.rootPage = LoginPage;
    }

    this.initializeApp();

    this.pages = [
      {title: 'Dashboard', component: TabsPage, icon: 'readycash-dbw', index: 0},

      {title: 'Register Agent', component: AgentPage, icon: 'readycash-ag'}, // , index: 1

      {title: 'Account Opening', component: BanksPage, icon: 'readycash-oa'},

      {title: 'Transactions', component: TransactionsPage, icon: 'readycash-mb', index: 2},

      {title: 'Challenges', component: EventsPage, icon: 'readycash-ev'},

      {title: 'Cash Pick Up', component: CashPickupPage, icon: 'readycash-cp'},

      {title: 'Pending Transaction', component: PendingTransactionPage, icon: 'readycash-pe'},
    ];

    platform.ready().then(() => {
    //  this.pushSetup();
      // this.agentInfo = JSON.parse(window.localStorage.getItem('agentObj'));
    });

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //this.nav.setRoot(page.component);


    if (page.index != undefined) {
      const navs = this.nav.getActiveChildNavs();
      navs.length && navs[0].select(page.index);

    } else if (page.component == null) {
      this.presentLogOutConfirm();
    } else {
      //this.nav.setRoot(page.component);
      this.nav.push(page.component);
    }


  }

  isActive(page) {
    let navs = this.nav.getActiveChildNavs();
    let childNav = navs[0];

    if (childNav) {
      if (childNav.getSelected() && childNav.getSelected().root === page.component) {
        return 'light';
      }
      return;
    }

  }


  goToPage(page: string) {
    this.nav.push(page);
  }

  goToProfile() {
    this.nav.push(ProfilePage);
  }

  logout() {
    this.auth.logout();
    this.nav.setRoot(LoginPage);
  }

  presentLogOutConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Are you sure you want to logout?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
           // console.log('Cancel clicked');
          }
        },
        {
          text: 'Logout',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts